import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/DeletePendingUser";

export function* deletePendingUser(action: Actions.DeletePendingUserAction) {
    const { payload } = action;
    const { credentials, organizationId, props } = payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });

        yield put(loading(true, action));
        yield api.deletePendingUser(organizationId, props);
        yield put(Actions.deletePendingUserEnd(undefined, organizationId, props));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.deletePendingUserEnd(e, organizationId, props));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchDeletePendingUser() {
    yield takeEvery(Actions.DELETE_PENDING_USER, deletePendingUser);
}
